import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/Board/cards/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const ADD_CARD_FRONTS = NAMESPACE + 'ADD_CARD_FRONTS'
export const SET = NAMESPACE + 'SET'
export const SET_ARRAY = NAMESPACE + 'SET_ARRAY'
export const REMOVE_ARRAY = NAMESPACE + 'REMOVE_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_BOARD_ID = NAMESPACE + 'SET_BOARD_ID'
export const SET_LIST_ID = NAMESPACE + 'SET_LIST_ID'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_DUE_DATE = NAMESPACE + 'SET_DUE_DATE'
export const SET_DUE_DATE_ID = NAMESPACE + 'SET_DUE_DATE_ID'
export const SET_START_DATE = NAMESPACE + 'SET_START_DATE'
export const SET_START_DATE_ID = NAMESPACE + 'SET_START_DATE_ID'
export const SET_LIST_CHANGE_DATE = NAMESPACE + 'SET_LIST_CHANGE_DATE'
export const SET_STATUS_CHANGE_DATE = NAMESPACE + 'SET_STATUS_CHANGE_DATE'
export const SET_LIST_CHANGED_BY = NAMESPACE + 'SET_LIST_CHANGED_BY'
export const SET_STATUS_CHANGED_BY = NAMESPACE + 'SET_STATUS_CHANGED_BY'
export const SET_STATUS = NAMESPACE + 'SET_STATUS'
export const SET_ARCHIVED = NAMESPACE + 'SET_ARCHIVED'
export const SET_IS_TEMPLATE = NAMESPACE + 'SET_IS_TEMPLATE'
export const INCREASE_FILE_COUNT = NAMESPACE + 'INCREASE_FILE_COUNT'
export const DECREASE_FILE_COUNT = NAMESPACE + 'DECREASE_FILE_COUNT'
export const INCREASE_CHECKLIST_ITEM_COUNT = NAMESPACE + 'INCREASE_CHECKLIST_ITEM_COUNT'
export const DECREASE_CHECKLIST_ITEM_COUNT = NAMESPACE + 'DECREASE_CHECKLIST_ITEM_COUNT'
export const INCREASE_COMPLETED_CHECKLIST_ITEM_COUNT = NAMESPACE + 'INCREASE_COMPLETED_CHECKLIST_ITEM_COUNT'
export const DECREASE_COMPLETED_CHECKLIST_ITEM_COUNT = NAMESPACE + 'DECREASE_COMPLETED_CHECKLIST_ITEM_COUNT'
export const INCREASE_NOTE_COUNT = NAMESPACE + 'INCREASE_NOTE_COUNT'
export const DECREASE_NOTE_COUNT = NAMESPACE + 'DECREASE_NOTE_COUNT'
export const INCREASE_COMMENT_COUNT = NAMESPACE + 'INCREASE_COMMENT_COUNT'
export const DECREASE_COMMENT_COUNT = NAMESPACE + 'DECREASE_COMMENT_COUNT'
export const SET_RESPONSIBLE = NAMESPACE + 'SET_RESPONSIBLE'
export const REMOVE_RESPONSIBLE = NAMESPACE + 'REMOVE_RESPONSIBLE'
export const ADD_USER = NAMESPACE + 'ADD_USER'
export const REMOVE_USER = NAMESPACE + 'REMOVE_USER'
export const ADD_LABEL = NAMESPACE + 'ADD_LABEL'
export const REMOVE_LABEL = NAMESPACE + 'REMOVE_LABEL'
export const REMOVE_LABEL_FROM_ALL_CARDS = NAMESPACE + 'REMOVE_LABEL_FROM_ALL_CARDS'
export const REMOVE_STATUS_FROM_ALL_CARDS = NAMESPACE + 'REMOVE_STATUS_FROM_ALL_CARDS'
export const SET_POSITIONS = NAMESPACE + 'SET_POSITIONS'
export const SET_STATUS_POSITIONS = NAMESPACE + 'SET_STATUS_POSITIONS'
export const SET_RELATED_CARD_DATES = NAMESPACE + 'SET_RELATED_CARD_DATES'
export const SET_BLOCKER_COUNT = NAMESPACE + 'SET_BLOCKER_COUNT'

export const initialState = {}

export const cardDefaults = {
  boardId: null,
  name: '',
  responsible: null,
  users: [],
  labels: [],
  dueDate: null,
  dueDateId: null,
  startDate: null,
  startDateId: null,
  listChangeDate: null,
  statusChangeDate: null,
  listChangedBy: null,
  statusChangedBy: null,
  statusId: null,
  checklistItemCount: 0,
  completedChecklistItemCount: 0,
  noteCount: 0,
  commentCount: 0,
  fileCount: 0,
  ancestorCardsDates: [],
  descendantCardsDates: [],
  prevCardDates: [],
  nextCardDates: [],
  blockerCount: 0,
  isArchived: false,
  isTemplate: false,
  position: 0,
  listId: null,
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case ADD:
      return {
        ...state,
        [action.payload.id]: {
          ...cardDefaults,
          ...state[action.payload.id],
          ...action.payload
        }
      }
    case ADD_ARRAY: {
      const newState = {
        ...state
      }
      action.payload.forEach(card => {
        newState[card.id] = {
          ...cardDefaults,
          ...state[card.id],
          ...card
        }
      })
      return newState
    }
    case ADD_CARD_FRONTS: {
      const newState = {
        ...state
      }
      action.payload.forEach(Card => {
        newState[Card.Id] = {
          ...cardDefaults,
          ...state[Card.Id],
          id: Card.Id,
          boardId: Card.BoardId,
          name: Card.Name,
          statusId: Card.StatusId,
          statusPosition: Card.StatusPosition,
          statusChangeDate: Card.StatusChangeDate,
          statusChangedBy: Card.StatusChangedBy,
          responsible: Card.ResponsibleUserId,
          users: Card.Users.filter(userId => userId !== Card.ResponsibleUserId),
          labels: Card.Labels,
          dueDate: Card.DueDate,
          dueDateId: Card.DueDateId,
          startDate: Card.StartDate,
          startDateId: Card.StartDateId,
          checklistItemCount: Card.ChecklistItemsCount,
          completedChecklistItemCount: Card.CompletedChecklistItemsCount,
          isTemplate: Card.IsTemplate,
          isArchived: Card.IsArchived,
          listId: Card.ListId,
          position: Card.Position,
          listChangeDate: Card.ListChangeDate,
          listChangedBy: Card.ListChangedBy,
          creationDate: Card.CreationDate,
          createdBy: Card.CreatedBy,
        }
      })
      return newState
    }
    case SET:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...cardDefaults,
          ...state[action.payload.id],
          ...action.payload
        }
      } : state
    case SET_ARRAY: {
      const newState = {
        ...state
      }
      action.payload.forEach(card => {
        if (!state[card.id]) return

        newState[card.id] = {
          ...cardDefaults,
          ...state[card.id],
          ...card
        }
      })
      return newState
    }
    case REMOVE_ARRAY: {
      let newState = {
        ...state
      }
      action.payload.forEach(id => {
        delete newState[id]
      })
      return newState
    }
    case REMOVE: {
      let newState = {
        ...state
      }
      delete newState[action.payload.id]
      return newState
    }
    case SET_BOARD_ID:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          boardId: action.payload.boardId
        }
      } : state
    case SET_LIST_ID:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          listId: action.payload.listId
        }
      } : state
    case SET_NAME:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          name: action.payload.name
        }
      } : state
    case SET_DUE_DATE:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          dueDate: action.payload.dueDate
        }
      } : state
    case SET_DUE_DATE_ID:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          dueDateId: action.payload.dueDateId
        }
      } : state
    case SET_START_DATE:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          startDate: action.payload.startDate
        }
      } : state
    case SET_START_DATE_ID:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id], 
          startDateId: action.payload.startDateId
        }
      } : state
    case SET_LIST_CHANGE_DATE:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          listChangeDate: action.payload.listChangeDate
        }
      } : state
    case SET_STATUS_CHANGE_DATE:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          statusChangeDate: action.payload.statusChangeDate
        }
      } : state
    case SET_LIST_CHANGED_BY:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          listChangedBy: action.payload.listChangedBy
        }
      } : state
    case SET_STATUS_CHANGED_BY:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          statusChangedBy: action.payload.statusChangedBy
        }
      } : state
    case SET_STATUS:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          statusId: action.payload.statusId
        }
      } : state
    case SET_ARCHIVED:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          isArchived: action.payload.isArchived
        }
      } : state
    case SET_IS_TEMPLATE:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          isTemplate: action.payload.isTemplate
        }
      } : state
    case INCREASE_FILE_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          fileCount: state[action.payload.id].fileCount + action.payload.count
        }
      } : state
    case DECREASE_FILE_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          fileCount: state[action.payload.id].fileCount - action.payload.count
        }
      } : state
    case INCREASE_CHECKLIST_ITEM_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          checklistItemCount: state[action.payload.id].checklistItemCount + action.payload.count
        }
      } : state
    case DECREASE_CHECKLIST_ITEM_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          checklistItemCount: state[action.payload.id].checklistItemCount - action.payload.count
        }
      } : state
    case INCREASE_COMPLETED_CHECKLIST_ITEM_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          completedChecklistItemCount: state[action.payload.id].completedChecklistItemCount + action.payload.count
        }
      } : state
    case DECREASE_COMPLETED_CHECKLIST_ITEM_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          completedChecklistItemCount: state[action.payload.id].completedChecklistItemCount - action.payload.count
        }
      } : state
    case INCREASE_NOTE_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          noteCount: state[action.payload.id].noteCount + action.payload.count
        }
      } : state
    case DECREASE_NOTE_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          noteCount: state[action.payload.id].noteCount - action.payload.count
        }
      } : state
    case INCREASE_COMMENT_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          commentCount: state[action.payload.id].commentCount + action.payload.count
        }
      } : state
    case DECREASE_COMMENT_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          commentCount: state[action.payload.id].commentCount - action.payload.count
        }
      } : state
    case SET_RESPONSIBLE: {
      if (
        !state[action.payload.id] ||
        state[action.payload.id].responsible === action.payload.responsible
      ) return state

      const newCardStart = {
        ...state[action.payload.id]
      }

      if (state[action.payload.id].responsible) {
        newCardStart.users = addUniqueValueToArray({
          array: newCardStart.users,
          value: state[action.payload.id].responsible
        })
      }

      if (state[action.payload.id].users.indexOf(action.payload.responsible) !== -1) {
        newCardStart.users = newCardStart.users.filter(id => id !== action.payload.responsible)
      }

      newCardStart.responsible = action.payload.responsible

      return {
        ...state,
        [action.payload.id]: newCardStart
      }
    }
    case REMOVE_RESPONSIBLE:
      return (
        state[action.payload.id] &&
        state[action.payload.id].responsible
      )
        ? {
          ...state,
          [action.payload.id]: {
            ...state[action.payload.id],
            responsible: null
          }
        }
        : state
    case ADD_USER:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          users: addUniqueValueToArray({
            array: state[action.payload.id].users,
            value: action.payload.userId,
            index: action.payload.index
          })
        }
      } : state
    case REMOVE_USER:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          users: state[action.payload.id].users.filter(id => id !== action.payload.userId)
        }
      } : state
    case ADD_LABEL:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          labels: addUniqueValueToArray({
            array: state[action.payload.id].labels,
            value: action.payload.labelId,
            index: action.payload.index
          })
        }
      } : state
    case REMOVE_LABEL:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          labels: state[action.payload.id].labels.filter(id => id !== action.payload.labelId)
        }
      } : state
    case REMOVE_LABEL_FROM_ALL_CARDS: {
      let newState = {
        ...state
      }

      Object.keys(newState).map(key => newState[key]).forEach(card => {
        const labelIndex = card.labels.indexOf(action.payload.labelId)
        if (labelIndex !== -1) {
          newState[card.id] = {
            ...newState[card.id],
            labels: [
              ...newState[card.id].labels.slice(0, labelIndex),
              ...newState[card.id].labels.slice(labelIndex + 1)
            ]
          }
        }
      })

      return newState
    }
    case REMOVE_STATUS_FROM_ALL_CARDS: {
      let newState = {
        ...state
      }

      Object.keys(newState).map(key => newState[key]).forEach(card => {
        if (card.statusId === action.payload.status) {
          newState[card.id] = {
            ...newState[card.id],
            status: null
          }
        }
      })

      return newState
    }
    case SET_POSITIONS: {
      const newState = {
        ...state
      }
      action.payload.positions.forEach(pos => {
        if (newState[pos.id]) {
          newState[pos.id] = {
            ...newState[pos.id],
            position: pos.position
          }
        }
      })
      return newState
    }
    case SET_STATUS_POSITIONS: {
      const newState = {
        ...state
      }
      action.payload.positions.forEach(pos => {
        if (newState[pos.id]) {
          newState[pos.id] = {
            ...newState[pos.id],
            statusPosition: pos.position
          }
        }
      })
      return newState
    }
    case SET_RELATED_CARD_DATES: {
      let newState = {
        ...state
      }

      let changed = false

      Object.keys(state).forEach(key => {
        const card = state[key]

        if (card.ancestorCardsDates) {
          const length = card.ancestorCardsDates.length

          for (let i = 0; i < length; i++) {
            if (action.payload.id === card.ancestorCardsDates[i].id) {
              changed = true

              const ancestorCardsDates = [
                ...card.ancestorCardsDates
              ]

              ancestorCardsDates[i] = {
                ...card.ancestorCardsDates[i],
                ...action.payload
              }

              newState = {
                ...newState,
                [card.id]: {
                  ...newState[card.id],
                  ancestorCardsDates
                }
              }
            }
          }
        }

        if (card.descendantCardsDates) {
          const length = card.descendantCardsDates.length

          for (let i = 0; i < length; i++) {
            if (action.payload.id === card.descendantCardsDates[i].id) {
              changed = true

              const descendantCardsDates = [
                ...card.descendantCardsDates
              ]

              descendantCardsDates[i] = {
                ...card.descendantCardsDates[i],
                ...action.payload
              }

              newState = {
                ...newState,
                [card.id]: {
                  ...newState[card.id],
                  descendantCardsDates
                }
              }
            }
          }
        }

        if (card.prevCardDates) {
          const length = card.prevCardDates.length

          for (let i = 0; i < length; i++) {
            if (action.payload.id === card.prevCardDates[i].id) {
              changed = true

              const prevCardDates = [
                ...card.prevCardDates
              ]

              prevCardDates[i] = {
                ...card.prevCardDates[i],
                ...action.payload
              }

              newState = {
                ...newState,
                [card.id]: {
                  ...newState[card.id],
                  prevCardDates
                }
              }
            }
          }
        }

        if (card.nextCardDates) {
          const length = card.nextCardDates.length

          for (let i = 0; i < length; i++) {
            if (action.payload.id === card.nextCardDates[i].id) {
              changed = true

              const nextCardDates = [
                ...card.nextCardDates
              ]

              nextCardDates[i] = {
                ...card.nextCardDates[i],
                ...action.payload
              }

              newState = {
                ...newState,
                [card.id]: {
                  ...newState[card.id],
                  nextCardDates
                }
              }
            }
          }
        }
      })

      return changed ? newState : state
    }
    case SET_BLOCKER_COUNT:
      return state[action.payload.id] ? {
        ...state,
        [action.payload.id]: {
          ...state[action.payload.id],
          blockerCount: action.payload.blockerCount
        }
      } : state
    default: return state
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function addArray (cardArray) {
  return {
    type: ADD_ARRAY,
    payload: cardArray
  }
}

export function addCardFronts (cardFrontsArray) {
  return {
    type: ADD_CARD_FRONTS,
    payload: cardFrontsArray
  }
}

export function set (data) {
  return {
    type: SET,
    payload: data
  }
}

export function setArray (cardArray) {
  return {
    type: SET_ARRAY,
    payload: cardArray
  }
}

export function removeArray (cardArray) {
  return {
    type: REMOVE_ARRAY,
    payload: cardArray
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setBoardId ({ id, boardId }) {
  return {
    type: SET_BOARD_ID,
    payload: {
      id,
      boardId
    }
  }
}

export function setListId ({ id, listId }) {
  return {
    type: SET_LIST_ID,
    payload: {
      id,
      listId
    }
  }
}

export function setName ({ id, name }) {
  return {
    type: SET_NAME,
    payload: {
      id,
      name
    }
  }
}

export function setDueDate ({ id, dueDate }) {
  return {
    type: SET_DUE_DATE,
    payload: {
      id,
      dueDate
    }
  }
}

export function setDueDateId ({ id, dueDateId }) {
  return {
    type: SET_DUE_DATE_ID,
    payload: {
      id,
      dueDateId
    }
  }
}

export function setStartDate ({ id, startDate }) {
  return {
    type: SET_START_DATE,
    payload: {
      id,
      startDate
    }
  }
}

export function setStartDateId ({ id, startDateId }) {
  return {
    type: SET_START_DATE_ID,
    payload: {
      id,
      startDateId
    }
  }
}

export function setListChangeDate ({ id, listChangeDate }) {
  return {
    type: SET_LIST_CHANGE_DATE,
    payload: {
      id,
      listChangeDate
    }
  }
}

export function setStatusChangeDate ({ id, statusChangeDate }) {
  return {
    type: SET_STATUS_CHANGE_DATE,
    payload: {
      id,
      statusChangeDate
    }
  }
}

export function setListChangedBy ({ id, listChangedBy }) {
  return {
    type: SET_LIST_CHANGED_BY,
    payload: {
      id,
      listChangedBy
    }
  }
}

export function setStatusChangedBy ({ id, statusChangedBy }) {
  return {
    type: SET_STATUS_CHANGED_BY,
    payload: {
      id,
      statusChangedBy
    }
  }
}

export function setStatus ({ id, statusId }) {
  return {
    type: SET_STATUS,
    payload: {
      id,
      statusId
    }
  }
}

export function setArchived ({ id, isArchived }) {
  return {
    type: SET_ARCHIVED,
    payload: {
      id,
      isArchived
    }
  }
}

export function setIsTemplate ({ id, isTemplate }) {
  return {
    type: SET_IS_TEMPLATE,
    payload: {
      id,
      isTemplate
    }
  }
}

export function increaseFileCount ({ id, count = 1 }) {
  return {
    type: INCREASE_FILE_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function decreaseFileCount ({ id, count = 1 }) {
  return {
    type: DECREASE_FILE_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function increaseChecklistItemCount ({ id, count = 1 }) {
  return {
    type: INCREASE_CHECKLIST_ITEM_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function decreaseChecklistItemCount ({ id, count = 1 }) {
  return {
    type: DECREASE_CHECKLIST_ITEM_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function increaseCompletedChecklistItemCount ({ id, count = 1 }) {
  return {
    type: INCREASE_COMPLETED_CHECKLIST_ITEM_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function decreaseCompletedChecklistItemCount ({ id, count = 1 }) {
  return {
    type: DECREASE_COMPLETED_CHECKLIST_ITEM_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function increaseNoteCount ({ id, count = 1 }) {
  return {
    type: INCREASE_NOTE_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function decreaseNoteCount ({ id, count = 1 }) {
  return {
    type: DECREASE_NOTE_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function increaseCommentCount ({ id, count = 1 }) {
  return {
    type: INCREASE_COMMENT_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function decreaseCommentCount ({ id, count = 1 }) {
  return {
    type: DECREASE_COMMENT_COUNT,
    payload: {
      id,
      count
    }
  }
}

export function setResponsible ({ id, responsible }) {
  return {
    type: SET_RESPONSIBLE,
    payload: {
      id,
      responsible
    }
  }
}

export function removeResponsible ({ id }) {
  return {
    type: REMOVE_RESPONSIBLE,
    payload: {
      id
    }
  }
}

export function addUser ({ id, userId, index }) {
  return {
    type: ADD_USER,
    payload: {
      id,
      userId,
      index
    }
  }
}

export function removeUser ({ id, userId }) {
  return {
    type: REMOVE_USER,
    payload: {
      id,
      userId
    }
  }
}

export function addLabel ({ id, labelId, index }) {
  return {
    type: ADD_LABEL,
    payload: {
      id,
      labelId,
      index
    }
  }
}

export function removeLabel ({ id, labelId }) {
  return {
    type: REMOVE_LABEL,
    payload: {
      id,
      labelId
    }
  }
}

export function removeLabelFromAllCards ({ labelId }) {
  return {
    type: REMOVE_LABEL_FROM_ALL_CARDS,
    payload: {
      labelId
    }
  }
}

export function removeStatusFromAllCards ({ status }) {
  return {
    type: REMOVE_STATUS_FROM_ALL_CARDS,
    payload: {
      status
    }
  }
}

export function setPositions (positions) {
  return {
    type: SET_POSITIONS,
    payload: {
      positions
    }
  }
}

export function setStatusPositions (positions) {
  return {
    type: SET_STATUS_POSITIONS,
    payload: {
      positions
    }
  }
}

export function setRelatedCardDates ({ id, ...data }) {
  return {
    type: SET_RELATED_CARD_DATES,
    payload: {
      id,
      ...data
    }
  }
}

export function setBlockerCount ({ id, blockerCount }) {
  return {
    type: SET_BLOCKER_COUNT,
    payload: {
      id,
      blockerCount,
    }
  }
}
